/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import icClose from 'static/ic-close.png';
import "./ModalHistory.scss";
import btnVoucher from 'static/btn-voucher.png';
import { PRIZE_TEXT, PRIZE_TYPE, PRIZE_ICON, MODAL_TYPE, HISTORY_LIST, NATIVE_ACTION, GAME_CODE_THEME_NEW } from 'helpers/constants';
import icEmpty from 'static/ic-history-empty.png';
import btnMagic from 'static/btn-magic.png';
import { getHistoryFilter } from 'services';
import { connect } from 'react-redux';
import { renderDate } from 'helpers/helpers';
import PuzzleStorage from './PuzzleStorage';
import styled from 'styled-components';
import { handleNativeAction } from 'helpers/nativeActions';
import { getGameAsset } from 'helpers/gameAssets';
import icMoney from 'static/ic-money.png';

const Loading = styled.div`
    position: unset;
    float: none;
    background: transparent;
    padding-top: 20vh;
`
const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`
function ModalHistory({ isOpen, onCloseModal, getHistoryFilter, gameCode }) {
    const [selected, onChangeSelect] = useState(PRIZE_TYPE.COIN);
    const [histories, setHistory] = useState([]);
    const [modal, openModal] = useState(false);
    const [loading, setLoading] = useState(true);

    const prizeText = (prizeType) => GAME_CODE_THEME_NEW.includes(gameCode) && prizeType === PRIZE_TYPE.MONEY
        ? 'tiền mặt'
        : PRIZE_TEXT[prizeType];

    useEffect(() => isOpen && getHistoryList(GAME_CODE_THEME_NEW.includes(gameCode) ? PRIZE_TYPE.MONEY : PRIZE_TYPE.COIN), [isOpen, gameCode]);
    const getHistoryList = async (prizeType) => {
        if (!isOpen) return;
        setHistory([]);
        onChangeSelect(prizeType);
        setLoading(true);
        const result = await getHistoryFilter({ gameCode: gameCode, prizeType: prizeType });
        if (result && result.historyList) {
            setHistory([...result.historyList]);
        }
        setLoading(false);
        // // Test history
        // setHistory([...HISTORY_LIST]);
    }

    return (
        <>
            <Modal open={isOpen} onClose={onCloseModal} gameCode={gameCode}>
                <div className="d-flex h-100" >
                    <div className='nav-bar'>
                        {GAME_CODE_THEME_NEW.includes(gameCode) ?
                            <p className={`${selected === PRIZE_TYPE.MONEY && "selected"}`} onClick={() => selected !== PRIZE_TYPE.MONEY && getHistoryList(PRIZE_TYPE.MONEY)}>{prizeText(PRIZE_TYPE.MONEY)}</p> :
                            <>
                                <p className={`${selected === PRIZE_TYPE.COIN && "selected"}`} onClick={() => selected !== PRIZE_TYPE.COIN && getHistoryList(PRIZE_TYPE.COIN)}>{PRIZE_TEXT[PRIZE_TYPE.COIN]}</p>
                                <p className={`${selected === PRIZE_TYPE.MONEY && "selected"}`} onClick={() => selected !== PRIZE_TYPE.MONEY && getHistoryList(PRIZE_TYPE.MONEY)}>{PRIZE_TEXT[PRIZE_TYPE.MONEY]}</p>
                                <p className={`${selected === PRIZE_TYPE.VOUCHER && "selected"}`} onClick={() => selected !== PRIZE_TYPE.VOUCHER && getHistoryList(PRIZE_TYPE.VOUCHER)}>{PRIZE_TEXT[PRIZE_TYPE.VOUCHER]}</p>
                                <p className={`${selected === PRIZE_TYPE.MAGIC && "selected"}`} onClick={() => selected !== PRIZE_TYPE.MAGIC && getHistoryList(PRIZE_TYPE.MAGIC)}>{PRIZE_TEXT[PRIZE_TYPE.MAGIC]}</p>
                                <p className={`${selected === PRIZE_TYPE.LUCKY_CODE && "selected"}`} onClick={() => selected !== PRIZE_TYPE.LUCKY_CODE && getHistoryList(PRIZE_TYPE.LUCKY_CODE)}>{PRIZE_TEXT[PRIZE_TYPE.LUCKY_CODE]}</p>
                            </>
                        }
                    </div>
                    <div className='main'>
                        <div className="items-center modal-header">
                            {histories.length > 0 && selected === PRIZE_TYPE.VOUCHER ?
                                <a href={process.env.REACT_APP_DEEP_LINK_VOUCHER}>
                                    <img className='btn-link-to' src={btnVoucher} />
                                </a> : histories.length > 0 && selected === PRIZE_TYPE.MAGIC ?
                                    <img className='btn-link-to' src={btnMagic} onClick={() => {
                                        handleNativeAction(NATIVE_ACTION.INS_QUAYONG_GHEPMANH_VIEW);
                                        openModal(MODAL_TYPE.FUSION);
                                        setTimeout(() => { onChangeSelect(PRIZE_TYPE.COIN); }, 100);

                                    }} /> :
                                    <img className='btn-link-to' style={{ visibility: "hidden" }} />}

                            <p className="mr-48 upper-case">
                                {prizeText(selected)}
                            </p>
                            <img className="icon-header" src={icClose} onClick={() => {
                                onCloseModal();
                                setTimeout(() => { onChangeSelect(PRIZE_TYPE.COIN); }, 100);
                            }} />
                        </div>

                        <div className='history-list'>
                            {!loading && histories.length > 0 ? histories.map((item, index) => {
                                return <Item

                                    icon={selected === PRIZE_TYPE.MONEY
                                        ? getGameAsset(gameCode, 'ic-money', icMoney)
                                        : PRIZE_ICON[selected]}
                                    content={item.giftRewardDescription}
                                    date={renderDate(item.createdDate, "DD/MM/YYYY HH:mm:ss")}
                                    customClass={`${index === histories.length - 1 && 'border-0'}`}
                                />
                            }
                            ) : <div className='empty'>
                                    {loading ?
                                        <Loading className="overlay">
                                            <Spinner className="spinner" />
                                        </Loading> :
                                        <>
                                            <img src={icEmpty} alt="ic-empty" style={{ width: "13.875rem" }} />
                                            <p>{`Hiện tại không có lịch sử ${selected === PRIZE_TYPE.COIN || selected === PRIZE_TYPE.VOUCHER ? "quà tặng" : "trúng giải"} ${selected === PRIZE_TYPE.MONEY ? prizeText(selected) : PRIZE_TEXT[selected]}.\nVui lòng quay trở lại sau`}</p>
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </Modal>

            <PuzzleStorage
                isOpen={modal === MODAL_TYPE.FUSION}
                onCloseModal={() => {
                    openModal(null);
                    onChangeSelect(PRIZE_TYPE.MAGIC);
                }}
                gameCode={gameCode}
                historyList={histories} />
        </>
    );
}

const Item = ({ icon, content, date, customClass }) => {
    return (
        <div className={`item ${customClass}`}>
            <div>
                <img className='item-icon' src={icon} />
            </div>

            <div className='item-content col-9 p-0'>{content}</div>
            <div className='item-date'>{date}</div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    getHistoryFilter: (params) => dispatch(getHistoryFilter(params)),

});

export default connect(null, mapDispatchToProps)(ModalHistory);